<template>
  <div>
    <b-card 
      class="text-center"
      bg-variant="primary"
      text-variant="white">
      <b-list-group flush>
        <b-list-group-item class="bg-primary text-light" style="padding:0 0 20px 0">Next scheduled scan is <b>{{ nextscan.schedule_name }}</b></b-list-group-item>
        <b-list-group-item class="bg-primary text-light" style="padding:20px 0">Next cut-off on <b>{{ nextscan.cut_off_date | moment('Do MMM') }}</b></b-list-group-item>
        <b-list-group-item class="bg-primary text-light" style="padding:20px 0 0 0">Next processed on <b>{{ nextscan.scan_date | moment('Do MMM') }}</b></b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  props: ['nextscan'],
};
</script>